import { createContext, useContext, useState } from "react";


export const ConfigsContext = createContext();

export function ConfigsContextProvider( { children })
{
  const [configs, setConfigs] = useState([]);

  return(
    <ConfigsContext.Provider value={ {configs, setConfigs } }>
      {children}
    </ConfigsContext.Provider>
  );
}
